import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';

import useStyles from './styles';

const RatingChip = ({ rating }) => {
	const classes = useStyles();

	return (
		<Chip
			icon={<StarIcon fontSize="small" />}
			color="primary"
			label={rating}
			size="small"
			className={classes.root}
		/>
	);
};

RatingChip.propTypes = {
	rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default RatingChip;
